import * as React from 'react';

import { UndergroundIcon } from '../../../common/components/underground_icon';
import { IAddressInfo } from '../../../types/geo/address';
import { IHighwayInfo } from '../../../types/geo/highway';
import { IUndergroundInfo } from '../../../types/geo/underground';
import { isArrayWithItems, isDefined, PREMIUM_REGIONS_IDS } from '../../../utils';
import { getUndergroundTime } from '../../../utils/formatters';
import { getCommuteTypeByRegionId } from '../../../utils/getCommuteTypeByRegionId';
import { ParentContainer } from '../../parent/container';
import { trackGeoAddressNodeClick, trackGeoUndergroundClick } from '../tracking';
import * as styles from './index.css';

export interface IOfferMapGeoProps {
  address: IAddressInfo[];
  undergrounds: IUndergroundInfo[] | null;
  highways: IHighwayInfo[] | null;
}

export class OfferMapGeo extends React.Component<IOfferMapGeoProps, {}> {
  public render() {
    const { address, undergrounds, highways } = this.props;

    if (!isArrayWithItems(address)) {
      return null;
    }

    const regionId = address[0].id;
    const addressElements = address.map((addr, index) => (
      <a
        data-testid="address_element"
        key={`addressElement_${index}`}
        href={addr.url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={trackGeoAddressNodeClick}
      >
        {addr.shortName}
      </a>
    ));

    return (
      <div className={styles['container']}>
        <ParentContainer containerClassName={styles['name']} withoutPretext />
        <div className={styles['address']} data-testid="address">
          {addressElements
            .slice(1)
            .reduce<(string | JSX.Element)[]>((xs, x) => xs.concat([', ', x]), [addressElements[0]])}
        </div>
        {!!undergrounds && (
          <div className={styles['undergrounds']} data-testid="undergrounds">
            {undergrounds.map(underground => renderUnderground(underground, regionId))}
          </div>
        )}
        {!!highways && (
          <div className={styles['highways']} data-testid="highways">
            {highways.map(highway => renderHighway(highway, regionId))}
          </div>
        )}
      </div>
    );
  }
}

function renderHighway(highway: IHighwayInfo, regionId: number) {
  return (
    <div key={`underground_${highway.name}`} className={styles['highway']}>
      <a href={highway.url} target="_blank" rel="noopener noreferrer">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11">
          <path
            fill="#757575"
            fillOpacity=".54"
            fillRule="evenodd"
            d="M10.037 1.506a.872.872 0 0 0-.83-.59H2.793a.877.877 0 0 0-.83.59L.75 5v4.667c0 .32.262.583.583.583h.584c.32 0 .583-.262.583-.583v-.584h7v.584c0 .32.262.583.583.583h.584c.32 0 .583-.262.583-.583V5l-1.213-3.494zM2.792 7.333a.874.874 0 1 1 0-1.75.874.874 0 1 1 0 1.75zm6.416 0a.874.874 0 1 1 0-1.75.874.874 0 1 1 0 1.75zm-7.29-2.916l.874-2.625h6.416l.875 2.625H1.917z"
          />
        </svg>
        {`${highway.name} шоссе`}
      </a>
      ,{' '}
      <span className={styles['highway-distance']}>
        {Math.round(highway.distance)} км от {getCommuteTypeByRegionId(regionId)}
      </span>
    </div>
  );
}

function renderUnderground(underground: IUndergroundInfo, regionId: number) {
  const size = PREMIUM_REGIONS_IDS.includes(regionId) ? 17 : 10;

  return (
    <div key={`underground_${underground.name}`} className={styles['underground']}>
      <a href={underground.url} target="_blank" rel="noopener noreferrer" onClick={trackGeoUndergroundClick}>
        <UndergroundIcon width={size} height={size} color={`#${underground.lineColor}`} regionId={regionId} />
        {underground.name}
      </a>
      {isDefined<number>(underground.travelTime) && underground.travelType && (
        <span className={styles['underground-time']}>{getUndergroundTime(underground)}</span>
      )}
    </div>
  );
}
